<div class="row mcr">
  <div class="col-md-6 form">
    <div class="logo1">
      <img src=".\assets\images\solapur_logo.png">
    </div>

    <h1 style="text-align: center; color: DodgerBlue;">Register as Agent</h1>

    <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
      <p class="alert-title"><b>Oh snap!</b></p>
      <ul class="alert-message-list">
        <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
      </ul>
    </nb-alert>

    <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
      <p class="alert-title"><b>Hooray!</b></p>
      <ul class="alert-message-list">
        <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
      </ul>
    </nb-alert>

    <div [formGroup]="registerForm" aria-labelledby="title">
      <div class="form-control-group">
        <label for="input-name">Company Name<span style="color:red; font-weight:bold">*</span></label>
        <input nbInput autofocus fullWidth fieldSize="large" id="input-name" formControlName="fullname"
          placeholder="Company Name">

        <span
          *ngIf="registerForm.controls.fullname.invalid && (registerForm.controls.fullname.dirty || registerForm.controls.fullname.touched)"><span
            style="color:red;">Company Name is required</span></span>
      </div>

      <div class="form-control-group">

        <div>
          <label for="inputMobile"> Country Code and Mobile number <span style="color:red;">* </span><i
              class="fa fa-info-circle" nbPopoverMode="hover"></i></label>
        </div>
      </div>
      <div class="form-control-group">
        <div></div>

        <input nbInput type="text" pattern="[0-9]{5,12}" class="form-control" placeholder="Mobile No" fieldSize="small"
          formControlName="mobile" class="countrycode" inputmode="numeric" digitOnly ng2TelInput
          [ng2TelInputOptions]="{separateDialCode:true}" (countryChange)="onCountryChange($event)"
          (keypress)="OnlyNoAllowed($event)"
          [ngClass]="{'form-control-danger': registerForm.controls.mobile.invalid && (registerForm.controls.mobile.dirty ||  registerForm.controls.mobile.touched)}"
          required>
        <span
          *ngIf="registerForm.controls.mobile.invalid && (registerForm.controls.mobile.dirty || registerForm.controls.mobile.touched)"><span
            style="color:red;">Mobile number is required</span></span>
      </div>

      <div class="form-control-group">
        <label for="input-email">Company Email address:<span style="color:red; font-weight:bold">*</span></label>
        <input nbInput (keyup)="onKeyPressNew($event)" nbInput fullWidth fieldSize="large" id="input-email"
          formControlName="email" [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : ''"
          [attr.aria-invalid]="email.invalid && email.touched ? true : null" placeholder="Email address">

        <span
          *ngIf="registerForm.controls.email.invalid && (registerForm.controls.email.dirty || registerForm.controls.email.touched)"><span
            style="color:red;">Email is required</span></span>
        <span style="color : red" *ngIf="emailExists == true">Email already exists.</span>
        <span style="color : red" *ngIf="registerForm.controls.email.value?.endsWith('@gmail.com')">Invalid
          EmailID</span>
      </div>

      <div class="form-control-group">
        <label for="input-password">Password:<span style="color:red; font-weight:bold">*</span></label>
        <input nbInput fullWidth fieldSize="large" id="input-password" formControlName="password" type="password"
          [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : ''" placeholder="Password">

        <span
          *ngIf="registerForm.controls.password.invalid && (registerForm.controls.password.dirty || registerForm.controls.password.touched)"><span
            style="color:red;">Password is required</span></span>
      </div>

      <div class="form-control-group">
        <label for="input-re-password">Confirm Password:<span style="color:red; font-weight:bold">*</span></label>
        <input nbInput fullWidth fieldSize="large" id="input-re-password" formControlName="confirmPassword"
          type="password"
          [status]="confirmPassword.dirty ? (confirmPassword.invalid || password.value != confirmPassword.value  ? 'danger' : 'success') : ''"
          placeholder="Password">

        <p class="caption status-danger" *ngIf="password.value != confirmPassword.value">
          Password and confirm password does not match!
        </p>
      </div>

      <div class="form-control-group">
        <label for="input-name">GST No</label>
        <input nbInput autofocus fullWidth fieldSize="large" id="input-name" formControlName="gstno"
          placeholder="GST No">
          <span *ngIf="registerForm.controls.gstno.invalid && (registerForm.controls.gstno.dirty || registerForm.controls.gstno.touched )">
            <span style="color:red;">Please enter valid GST Number</span></span><br> 
      </div>

      <div class="form-control-group">
        <label for="input-name">PAN No.<span style="color:red; font-weight:bold">*</span></label>
        <input nbInput autofocus fullWidth fieldSize="large" id="input-name" formControlName="panNo"
          placeholder="Pan No.">
          <span *ngIf="registerForm.controls.panNo.invalid && (registerForm.controls.panNo.dirty || registerForm.controls.panNo.touched )">
            <span style="color:red;">Please enter valid PAN Number</span></span><br> 
      </div>

      <div class="form-control-group">
        <label for="input-name">URL</label>
        <input nbInput autofocus fullWidth fieldSize="large" id="input-name" formControlName="url"
          placeholder="url">
      </div>

      <button nbButton fullWidth status="primary" size="large"
        [disabled]="submitted || !registerForm.valid || 
      password.value != confirmPassword.value || emailExists||registerForm.controls.email.value?.endsWith('@gmail.com')" [class.btn-pulse]="submitted"
        (click)="openTermsPopup()">
        Proceed
      </button>
    </div>

    <h6 class="login1" aria-label="Sign in">
      Already have an account? <a class="text-link" style="color:DodgerBlue;" routerLink="../login">Log in</a>
    </h6>
  </div>
  <div class="col-md-6 about">
    <div class="elip"></div>
    <div class="logo">
      <img src=".\assets\images\solapur_logo.png" style="width: 190px" alt="logo">
    </div>

    <div style="position: relative; ">
      <div style="position: absolute; z-index: 5; width: 100%;">
        <h4> Already have an account? <a style="color:DodgerBlue;" class="text-link" routerLink="../login">Login</a>
        </h4>
      </div>
    </div>

    <div class="imge">
      <img src="./../../../../assets/images/Recruitment Agencies ( verification).svg">
    </div>
  </div>
</div>

<p-dialog [(visible)]="displayNo" [modal]="true" [responsive]="true" [resizable]="false" [minY]="70"
  [baseZIndex]="10000">
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-11">
      <nb-checkbox [checked]="checked1" (checkedChange)="toggle1('condition1',$event)"> I am aware that the Solapur
        University/colleges that I am considering for application may communicate with me by mail, email, phone or text
        message/Whatsapp for my application.</nb-checkbox>



    </div>
  </div><br>
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-11">
      <nb-checkbox [checked]="checked2" (checkedChange)="toggle1('condition2',$event)">
        By checking this box, I represent that (i) I am age 13 or older and (ii) I have read, understood and agreed to
        the terms and conditions of the Terms of Use and Privacy Policy (unless I am over the age of 13 but under the
        age of 18, in which case, my parent or legal guardian has also read, understood and agreed to the terms and
        conditions of the Privacy Policy and Terms of Use sections).

      </nb-checkbox>
    </div>
  </div><br>
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-11">
      <nb-checkbox [checked]="checked3" (checkedChange)="toggle1('condition3',$event)">
        I accept that (I) Fees paid is not refundable And (II) All the information filled by me is true.

      </nb-checkbox>
    </div>
  </div><br>
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-11">
      <nb-checkbox [checked]="checked4" (checkedChange)="toggle1('condition4',$event)">
        Solapur University website uses small files stored on your computer, known as cookies, that help us remember
        your settings and ensure the website works properly. By continuing, I am agreeing to The Solapur University use
        of cookies.
      </nb-checkbox>
    </div>
  </div><br>

  <button nbButton fullWidth status="primary" size="large"
    [disabled]="submitted || !registerForm.valid || password.value != confirmPassword.value || !checked3 || !checked4"
    [class.btn-pulse]="submitted" (click)="register()">
    Register
  </button>
</p-dialog>

<p-dialog [(visible)]="emailverify" [modal]="true" [responsive]="true" [resizable]="false" [minY]="70"
  [baseZIndex]="10000">
  <h3>Kindly Change your Email Address</h3>
</p-dialog>

<p-dialog [(visible)]="registered" [modal]="true" [responsive]="true" [style]="{width: '500px;', minWidth: '500px'}"
  [minY]="70" [baseZIndex]="10000">
  <h3>Check your email inbox/spam for email verification and Activate the Account</h3>

</p-dialog>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>